import './topDestinations.css';

import { aroundYouTab } from '../geolocAroundYouTab/geolocAroundYouTab';
import { domainHighlightTpl } from '../domainHighlight/domainHighlightTpl';

export const td = {
  selectors: {
    main: '.js-td',
    tabsSelector: '.js-tabs'
  },
  wordings: GLOBAL_SCRIPTS.WORDINGS_CROSSSELL,

  initOrRefresh: options => {
    options = typeof options === 'object' ? options : {};

    $.extend(options, {
      originId: 'topdestinations',
      mainSelector: td.selectors.main,
      forceTabToShow: '',
      showTab: false
    });

    const historyCookie = cookieManagement.getCookie('productHistory'),
      hasMulticottage = typeof SEARCH_SCRIPTS !== 'undefined' && SEARCH_SCRIPTS.TOTALCOTTAGE > 1,
      isSunParks = GLOBAL_SCRIPTS.UNIVERS === 'sp';

    if (historyCookie && !hasMulticottage && !isSunParks) {
      td.initLastSeenDomains(options);
    } else {
      $('.tab[data-tabcode="LAST_SEEN"]').remove();
      td.initFavorites(options);
    }

    aroundYouTab.initOrRefresh($.extend(options, {
      additionnalAjaxParams: {
        c: 'SEARCH_' + GLOBAL_SCRIPTS.UNIVERS.toUpperCase() + '_LIGHT',
        nb: 6
      }
    }));

    td.initTracking();

    $(document).on('click', `${td.selectors.main} ${td.selectors.tabsSelector} .tab[data-tabcode=LAST_SEEN]`, () => {
      $.extend(options, {
        forceTabToShow: 'LAST_SEEN',
        showTab: true
      });
      td.initLastSeenDomains(options);
    });

    $(document).on('click', `${td.selectors.main} ${td.selectors.tabsSelector} .tab[data-tabcode=FAVORITES]`, () => {
      $.extend(options, {
        forceTabToShow: 'FAVORITES',
        showTab: true
      });
      td.initFavorites(options);
    });

    $(document).on('click', `${td.selectors.main} ${td.selectors.tabsSelector} .tab[data-tabcode=AROUND_USER]`, () => {
      $.extend(options, {
        forceTabToShow: 'AROUND_USER',
        showTab: true
      });
      aroundYouTab.initOrRefresh(options);
    });
  },

  /**
   * Init LastSeen tab content
   * @param options
   */
  initLastSeenDomains: (options) => {
    const tabName = 'LAST_SEEN';
    const $tabContentWrapper = $(`.td-elems[data-tabcode="${tabName}"]`);
    const tabDataset = $tabContentWrapper.data();
    const $tabToShow = $(`${options.mainSelector} ${td.selectors.tabsSelector} [data-tabcode="${tabName}"]`);
    const hasModel = typeof options.search_mainEngineModel !== typeof undefined;
    const historyCookie = cookieManagement.getCookie('productHistory');
    const historyCookieValue = historyCookie !== null ? historyCookie : false;

    /* Proceed to ajax call and html generation only when search_mainEngineModel has been sent or if placeholder still visible */
    if (historyCookieValue && (hasModel || $tabContentWrapper.find('.gb-list--item').first().is('.gb-list--item--placeholder'))) {
      // Set request parameters
      const ajaxParams = {
        language: GLOBAL_SCRIPTS.LANGUAGE_CODE,
        market: GLOBAL_SCRIPTS.MARKET_CODE,
        token: GLOBAL_SCRIPTS.SEARCH_TOKEN,
        univers: GLOBAL_SCRIPTS.UNIVERS,
        limit: tabDataset.parameters.max || 6,
        option: {
          preview: 0,
          photos: 'history',
          formats_results: ['500x375'].join(',')
        },
        cookie: historyCookieValue,
        accreditation: GLOBAL_SCRIPTS.ACCREDITATION,
        accreditationGroup: GLOBAL_SCRIPTS.ACCREDITATION_GROUP,
        cacheuser: GLOBAL_SCRIPTS.CACHE_USER
      };

      if (GLOBAL_SCRIPTS.CONTROLLER === 'default') {
        ajaxParams.option.selection = 'planet';
      }

      // AJAX Call to get product infos
      const ajaxData = {
        ajaxUrl: SEARCH_SCRIPTS.URL_API_BASE + '/product/history',
        ajaxParams: ajaxParams,
        successCallback: (callbackDatas) => {
          const {ages, nb_pets, nb_children, total, nb_adults, nb_seniors} = td.getParticipantsData(options);

          let newHtml = '';
          const resultCount = Object.keys(callbackDatas.results.results).length;
          if (callbackDatas && callbackDatas.status === 'success' && resultCount) {
            newHtml = '';
            $.each(callbackDatas.results.results, (index, product) => {
              // avoid errors when brand not returned
              if (typeof product.brand === typeof undefined) {
                product.brand = {
                  code: null,
                  name: null
                };
              }

              newHtml += domainHighlightTpl({
                blockClass: 'favorites-elem gb-list--item swiper-slide',
                product_datas: product,
                labelNew: td.wordings.label_new,
                labelRenovated: td.wordings.label_renovated,
                early_booking_label: td.wordings.early_booking_label,
                last_minute_label: td.wordings.last_minute_label,
                totalParticipants: total,
                participants: {
                  children: nb_children,
                  senior: nb_seniors,
                  adult: nb_adults,
                  pet: nb_pets
                }
              });
            });

            // add placeholder to fill row
            const nbMaxVignettes = GLOBAL_SCRIPTS.UNIVERS === 'sp' ? 2 : 3;
            newHtml += td.getPlaceholderTpl(nbMaxVignettes - resultCount);


            dispatcher.trigger('lazyload:update');

            Tracking.dataLayerPush({
              event: 'view_item_list',
              sub_event: 'view_accommodations',
              ecommerce: {
                items: Tracking.generateAccommodationsDatas({
                  datas: Object.entries(callbackDatas.results.results).map(result => {
                    result[1].additional_item_infos = {
                      item_adults_number: nb_adults,
                      item_seniors_number: nb_seniors,
                      item_children_number: nb_children,
                      item_number_person: nb_adults + nb_seniors + nb_children,
                      item_pets_number: nb_pets,
                      item_children_age: JSON.stringify(ages),
                      item_start_date: result[1].cache.date,
                      item_end_date: result[1].cache.dateEnd,
                      item_start_day_of_week: new Date(result[1].cache.date).toLocaleDateString(undefined, { weekday: 'long' }).replace(/\./gi, ''),
                      item_length_of_stay: genericDate.diff(new Date(result[1].cache.date), new Date(result[1].cache.dateEnd)),
                      multicottage: 'no'
                    };

                    return result[1];
                  })
                })
              }
            });
          }

          $tabContentWrapper.toggleClass('gb-simpleTxt', newHtml === '');

          // Set html content
          if (newHtml === '') {
            newHtml = td.wordings.error_msg;
          }

          $tabContentWrapper.find('.swiper-wrapper').html(newHtml);

          // Set active tab
          $tabToShow.removeClass('loading disableTabListener');
          dispatcher.trigger('tabs:setActiveTab', $tabToShow, false);

          // Refresh visual stuff
          dispatcher.trigger('lazyload:update');
        },
        dataType: 'json',
        type: 'GET'
      };

      genericAjaxCall(ajaxData);
    }
  },

  /**
   * Init Favorites tab content
   * @param options
   */
  initFavorites: (options) => {
    const tabName = 'FAVORITES';
    const $tabContentWrapper = $(`.td-elems[data-tabcode="${tabName}"]`);
    const tabDataset = $tabContentWrapper.data();
    const $tabToShow = $(`${options.mainSelector} ${td.selectors.tabsSelector} [data-tabcode="${tabName}"]`);
    const hasModel = typeof options.search_mainEngineModel !== typeof undefined;

    /* Proceed to ajax call and html generation only when search_mainEngineModel has been sent or if placeholder still visible */
    if (hasModel || $tabContentWrapper.find('.gb-list--item').first().is('.gb-list--item--placeholder')) {
      // Set request parameters
      const ajaxParams = {
        init: 1,
        language: GLOBAL_SCRIPTS.LANGUAGE_CODE,
        market: GLOBAL_SCRIPTS.MARKET_CODE,
        token: GLOBAL_SCRIPTS.SEARCH_TOKEN,
        item: tabDataset.parameters.item || '',
        c: GLOBAL_SCRIPTS.UNIVERS.toUpperCase() + '_PUSH_SEARCH',
        univers: GLOBAL_SCRIPTS.UNIVERS,
        type: tabDataset.parameters.type || '',
        page: 1,
        nb: tabDataset.parameters.max || 6,
        option: {
          preview: 0
        },
        accreditation: GLOBAL_SCRIPTS.ACCREDITATION,
        accreditationGroup: GLOBAL_SCRIPTS.ACCREDITATION_GROUP,
        cacheuser: GLOBAL_SCRIPTS.CACHE_USER
      };

      if (GLOBAL_SCRIPTS.CONTROLLER === 'default') {
        ajaxParams.option.selection = 'planet';
      }

      // AJAX Call to get product infos
      const ajaxData = {
        ajaxUrl: GLOBAL_SCRIPTS.URL_BASE_API + 'results',
        ajaxParams: ajaxParams,
        successCallback: (callbackDatas) => {
          const {ages, nb_pets, nb_children, total, nb_adults, nb_seniors} = td.getParticipantsData(options);
          let newHtml = '';
          const resultCount = Object.keys(callbackDatas.results.results).length;
          if (callbackDatas && callbackDatas.status === 'success' && resultCount) {
            newHtml = '';
            $.each(callbackDatas.results.results, (_index, product) => {
              newHtml += domainHighlightTpl({
                blockClass: 'favorites-elem gb-list--item swiper-slide',
                product_datas: product,
                labelNew: td.wordings.label_new,
                labelRenovated: td.wordings.label_renovated,
                early_booking_label: td.wordings.early_booking_label,
                last_minute_label: td.wordings.last_minute_label,
                totalParticipants: total,
                participants: {
                  children: nb_children,
                  senior: nb_seniors,
                  adult: nb_adults,
                  pet: nb_pets
                }
              });
            });

            // add placeholder to fill row
            const nbMaxVignettes = GLOBAL_SCRIPTS.UNIVERS === 'sp' ? 2 : 3;
            newHtml += td.getPlaceholderTpl(nbMaxVignettes - resultCount);

            Tracking.dataLayerPush({
              event: 'view_item_list',
              sub_event: 'view_accommodations',
              ecommerce: {
                items: Tracking.generateAccommodationsDatas({
                  datas: Object.entries(callbackDatas.results.results).map(result => {
                    result[1].additional_item_infos = {
                      item_adults_number: nb_adults,
                      item_seniors_number: nb_seniors,
                      item_children_number: nb_children,
                      item_number_person: nb_adults + nb_seniors + nb_children,
                      item_pets_number: nb_pets,
                      item_children_age: JSON.stringify(ages),
                      item_start_date: result[1].cache.date,
                      item_end_date: result[1].cache.dateEnd,
                      item_start_day_of_week: new Date(result[1].cache.date).toLocaleDateString(undefined, { weekday: 'long' }).replace(/\./gi, ''),
                      item_length_of_stay: genericDate.diff(new Date(result[1].cache.date), new Date(result[1].cache.dateEnd)),
                      multicottage: 'no'
                    };

                    return result[1];
                  })
                })
              }
            });
          }

          $tabContentWrapper.toggleClass('gb-simpleTxt', newHtml === '');

          // Set html content
          if (newHtml === '') {
            newHtml = td.wordings.error_msg;
          }

          $tabContentWrapper.find('.swiper-wrapper').html(newHtml);

          // Set active tab
          $tabToShow.removeClass('loading disableTabListener');
          dispatcher.trigger('tabs:setActiveTab', $tabToShow, false);

          // Refresh visual stuff
          dispatcher.trigger('lazyload:update');
        },
        dataType: 'json',
        type: 'GET'
      };

      genericAjaxCall(ajaxData);
    }
  },

  /**
   * Get participants data
   * @param options
   * @return {{total: number, nb_pets: number, ages: array, nb_children: number, nb_adults: number, nb_seniors: number}}
   */
  getParticipantsData: (options) => {
    const storedSearchParamsCookie = cookieManagement.getCookie('storedSearchParams');
    const storedSearchParams = storedSearchParamsCookie != null ? JSON.parse(storedSearchParamsCookie) : {};
    const hasModel = typeof options.search_mainEngineModel === 'object';
    const hasStored = typeof storedSearchParams.multiparticipants !== typeof undefined;
    const participants = hasModel ? options.search_mainEngineModel.get('multiparticipants')[0] : hasStored ? storedSearchParams.multiparticipants[0] : {};
    const nb_adults = hasModel ? participants.adults : (hasStored ? participants.adult.key : 2);
    const nb_seniors = hasModel ? participants.seniors : (hasStored && typeof participants.senior !== 'undefined' ? participants.senior.key : 0);
    const nb_pets = hasModel ? participants.pets : (hasStored ? participants.pet.key : 0);
    const ages = hasModel ? participants.ages : (hasStored && typeof participants.ages !== 'undefined' && participants.ages.length > 0 ? participants.ages.map(age => age.key) : []);
    const nb_children = ages.length;
    const total = hasModel ? options.search_mainEngineModel.get('totalParticipants') : nb_adults + nb_seniors + nb_children;
    return {ages, nb_adults, nb_seniors, nb_pets, nb_children, total};
  },

  /**
   * Init tracking data for tabs
   */
  initTracking: () => {
    const tabs = `${td.selectors.main} ${td.selectors.tabsSelector} .tab`;
    // disable default tracking
    $(tabs).addClass('disableTabTracking');
    // add override tracking
    $(document).on('click', tabs, e => {
      Tracking.dataLayerPush({
        clickCode: 'clickOnDestinationFilters',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'Nos destinations',
        gaLabel: $(e.currentTarget).text().trim(),
        event: 'clickEvent'
      });
    });
  },

  /**
   * Return one or more placeholder templates
   * @param {number} count
   * @return {string}
   */
  getPlaceholderTpl: (count) => {
    count = count < 0 ? 0 : count;
    return Array(count).fill('<div class="favorites-elem gb-list--item gb-list--item--placeholder swiper-slide" aria-hidden="true"></div>').join('');
  }
};